
define('ldsh!modules/accounts/users/detail/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (user.isRequest) {;
__p += '\n  <div class="spinner__container">\n    <i class="ri-loader-4-fill fa-spin"></i>\n  </div>\n';
 } else { ;
__p += '\n\n  ';
 if (user.isError) {;
__p += '\n    <div id="activationError" class="activationContent center response">\n      <i class="naranja fa fa-exclamation-circle" style="font-size: 120px;"></i>\n      <div class="text-message">\n        <span class="i18n size20" data-i18n="[html]ACCOUNTS.USERS.LBL_ERROR" id="errorTitle">' +
__e(user.response.responseJSON.title) +
'</span>\n      </div>\n      <div class="text-message">\n        <span class="i18n naranja size21" data-i18n="[html]ACCOUNTS.USERS.LBL_ERROR_' +
__e(user.status) +
'" id="errorMessage">' +
__e(user.response.responseJSON.detail) +
'</span>\n      </div>\n    </div>\n  ';
 } else { ;
__p += '\n    ';
 if (user.isNew()) { ;
__p += '\n      <p><strong class="i18n size20" data-i18n="ACCOUNTS.USERS.LBL_NEW_USER"></strong></p>\n  ';
 } else if (!myself) { ;
__p += '\n      <div class="flex align-center justify-space-between">\n        <strong class="i18n size20 pull-left" data-i18n="ACCOUNTS.USERS.LBL_USER_DETAIL"></strong>\n        ';
if (user.get('lastLogin')) { ;
__p += '\n          <div class="flex align-center gap-6">\n            <button\n              class="modalLoginHistoryLink btn--small--link flex align-center pr0 pl0"\n            > <i class="ayuda-context ri-information-line"></i>\n            </button>\n            <span\n              data-i18n="[html]ACCOUNTS.USERS.LAST_LOGIN"\n              data-i18n-options=\'{"lastLogin": "' +
__e(user.get(' lastLogin')) +
'"}\'\n            ></span>\n          </div>\n        ';
 } ;
__p += '\n      </div>\n      <div class="clearfix"></div>\n  ';
 } else {;
__p += '\n    <div class="flex align-center justify-space-between">\n      <span class="i18n" data-i18n="ACCOUNTS.USERS.LBL_USER_PROFILE"></span>\n      <div class="flex align-center gap-6">\n        <button\n          class="modalLoginHistoryLink btn--small--link flex align-center pr0 pl0"\n        > <i class="ayuda-context ri-information-line"></i> </button>\n        <span\n          data-i18n="[html]ACCOUNTS.USERS.LAST_LOGIN"\n          data-i18n-options=\'{"lastLogin": "' +
__e(user.get(' lastLogin')) +
'"}\'\n        ></span>\n      </div>\n    </div>\n  ';
 } ;
__p += '\n\n  <div id="messages-container"></div>\n\n  <form\n    id="form-accounts-users-detail"\n    method="POST"\n    class="bv-form mt24"\n    novalidate="novalidate"\n  >\n    <div id="form-user"></div>\n\n    ';
 if (!myself) { ;
__p += ' ';
 if (user.isNew()) { ;
__p += '\n      <p><strong class="i18n size18" data-i18n="ACCOUNTS.USERS.PRODUCTS_NEW_USER"></strong></p>\n    ';
 } else {;
__p += '\n      <p><strong class="i18n size18" data-i18n="ACCOUNTS.USERS.PRODUCTS"></strong></p>\n    ';
 } ;
__p += '\n      <div id="form-user-services"></div>\n    ';
 } ;
__p += '\n\n    <div class="flex align-center gap-12 justify-end mb24">\n      ';
 if (!myself) { ;
__p += '\n        <button id="cancelFormUser" type="button" class="btn--ghost i18n" data-i18n="ACCOUNTS.USERS.LBL_CANCEL"></button>\n      ';
 } ;
__p += '\n\n      <button id="submitButton" class="btn--primary js-save">\n        <i class="fa-li fa fa-spinner fa-spin" style="display: none;"></i> <span class="i18n" data-i18n="ACCOUNTS.USERS.LBL_SAVE"></span>\n      </button>\n    </div>\n  </form>\n  ';
 } ;
__p += '\n';
 } ;
__p += '\n\n<div id=\'renderModalServices\'></div>\n<div id=\'renderModalLoginHistory\'></div>\n';

}
return __p
};});

